import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { GoalSummaryLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/GoalSummaryLayout';
import {
  GoalSummarySectionOverride,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/Goals/MetaOverride';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import {
  useOnboardingPlannerViewSectionContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';

const GoalsSectionLayout = () => {
  const { resource } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  return (
    <FDStack direction={'column'} spacing={2} paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <FDBodyText color={'textDisabled'} value={'These goals are in priority order, with a potential exception for Retirement as Primary & Spouse retirements are combined into 1 item. In this case the goal will be at the spot of the highest priority retirement goal'} />
      <MetaCollectionRenderer collection={resource.attr('sectionData')} layout={GoalSummaryLayout} metaOverrideSet={GoalSummarySectionOverride} />
    </FDStack>
  );
};

GoalsSectionLayout.defaultProps = {};

GoalsSectionLayout.propTypes = {};

export { GoalsSectionLayout };
